<template>
    <div>
        <transition name="slide">
            <div class="right-sidebar-1">
                <div class="panel-title">
                    <span class="header-row">
                        <!-- <i class="fas fa-arrow-left"></i> -->
                        <i @click="closeSidebar" class="fas fa-arrow-left cursor-pointer medium-icon"></i>
                        <h4>Messages</h4>
                    </span>
                    <span>
                        <i class="fas fa-ellipsis-v cursor-pointer medium-icon"></i>
                    </span>
                </div>
                {{ notificationData.items.size }}
                <div class="mt-4" v-if="notificationData.total > 0">
                    <div class="message-list">
                        <ul>
                            <li class="message-item" v-for="(message, index) in notificationData.items" :key="index">
                                <div class="message-container">
                                    <div class="message-icon">
                                        <i :class="getNotificationIcons(message.type)"></i>
                                    </div>
                                    <div class="message-content">
                                        <strong>
                                            {{ message.headline }}
                                        </strong>
                                        <p class="small-datetime">{{ message.publishedDate | datetimeDisplay }}</p>
                                        <div v-html="message.content"></div>
                                        <div v-html="message.footer"></div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else>
                    You don't have any notifications in the last 30 days
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import common from "@/libs/common";
import { mapGetters, mapActions } from "vuex";

export default {
    name: 'Notification',
    props: {
        messages: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        ...mapGetters({
            form: "notification/form",
            notificationData: "notification/notificationData",
        })
    },
    mounted() {
        this.filterNotifications();
    },
    data() {
        return {

        };
    },
    methods: {
        ...mapActions({
            getMessages: "notification/getMessages",
            readMessages: "notification/readMessages",
        }),
        closeSidebar() {
            this.$emit('close');
        },
        getNotificationIcons(type) {
            return common.getNotificationIcons(type);
        },
        filterNotifications() {
            const body = {
                "page": 1,
                "limit": 10
            };
            this.getMessages(body);
        }
    },
};
</script>

<style scoped>
.right-sidebar-1 {
    position: fixed;
    top: 0;
    right: 0;
    width: 360px;
    height: 100vh;
    background-color: var(--white);
    box-shadow: -2px 0 5px rgba(233, 229, 229, 0.1);
    padding: 20px;
    z-index: 999;
}

.slide-enter-active,
.slide-leave-active {
    transition: transform 0.5s ease;
}

.slide-enter {
    transform: translateX(100%);
}

.slide-leave-to {
    transform: translateX(100%);
}

.small-datetime {
    font-size: 11px !important;
}

.message-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ddd
}

.bg-gray {
    background-color: var(--gray);
}

.message-container {
    display: flex;
    width: 100%;
}

.message-icon {
    width: 20px;
    font-size: 20px;
    margin-right: 10px;
    color: var(--blue);
}

.message-content {
    flex: 1;
}

/* Add a scrollable message list with overflow-y: auto */
.message-list {
    overflow-y: auto;
    flex-grow: 1;
    margin-top: 10px;
    max-height: calc(100vh - 60px);
}

/* Style for scrollbar */
.message-list::-webkit-scrollbar {
    width: 4px;

}

.message-list::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
}

/* Style for the message content */
.right-sidebar-1 ul {
    list-style: none;
    padding: 0;
}

.right-sidebar-1 ul li {
    margin-bottom: 20px;
}

.right-sidebar-1 ul li h3 {
    margin: 0;
    font-size: 18px;
    color: #333;
}

.right-sidebar-1 ul li p {
    font-size: 14px;
    color: #777;
}

.right-sidebar-1 ul li .action-btn {
    background-color: #007bff;
    color: #fff;
    border: none;
    padding: 8px 12px;
    cursor: pointer;
    border-radius: 4px;
    font-size: 14px;
}
</style>